export enum DatabaseLocation {
    default = "default",
    Documents = "Documents"
}
